export default __webpack_public_path__ + "static/media/84.2ccd5eca.png";